import React from "react";
import { sizeUnits } from "_constants";
import cx from "classnames";
import PropTypes from "prop-types";

import TitledInputDropdown from "components/TitledInputDropdown";
import { Translate } from "utils";

import styles from "forms/forms.css";

const { t } = new Translate();

const SizeField = ({
  field: { value = {}, name },
  label,
  form: { errors, setFieldValue, submitCount },
  isInline,
  isEdit,
  onEdit,
}) => {
  const unit = value.unit || sizeUnits[0];

  return (
    <div className={cx(styles.field, { [styles.inline]: isInline })}>
      <TitledInputDropdown
        dropdownValue={unit}
        dropdownValues={sizeUnits}
        isEdit={isEdit}
        isRequired={errors[name] && !!submitCount}
        onEdit={onEdit}
        onInput={(v) => setFieldValue(name, { unit, value: parseFloat(v) })}
        onSelect={(u) => setFieldValue(name, { ...value, unit: u })}
        title={label}
        value={value.value}
        valueExtractor={(u) => t(`units.${u}`, value.value || 2)}
      />
    </div>
  );
};

SizeField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.object,
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
    errors: PropTypes.object,
    submitCount: PropTypes.number,
  }),
  label: PropTypes.string,
  isInline: PropTypes.bool,
  isEdit: PropTypes.bool,
  onEdit: PropTypes.func,
};

SizeField.defaultProps = {
  isEdit: true,
};

export default SizeField;
